export default "__VITE_ASSET__60SDaLGA__"